import { getFunctions, httpsCallable } from 'firebase/functions';

const reprocessBump = async (videoId) => {
    const functions = getFunctions();
    const reprocessCaptionsCallable = httpsCallable(functions, 'reprocessCaptionsBump');

    try {
        const requestData = {
            'videoId': videoId
        };


        await reprocessCaptionsCallable(requestData);
    } catch (error) {
    }
};

export { reprocessBump };
